import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/Configuration/CreateHelpSiteController.js"
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import HelpSiteService from "../../Controller/Configuration/HelpSiteController";
function CreateHelpSite({ form, onClose, onSuccess, formList }) {
    
    const [formData, setFormData] = useState({ FormID: '', SubForm: '', HelpSite: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [subFormList, setSubFormList] = useState([]);
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    useEffect(() => {
       
        if (form) {
            fetchSubForm(form.FormID);
            setFormData({
                FormID: form.FormID,
                SubForm: form.SubForm,
                HelpSite: form.HelpSite
            });
            setErrors({});
        } else {
            setFormData({ FormID: '', SubForm: '', HelpSite: '' }); // Clear form data when switching to add mode
            setErrors({});
        }
    }, [form, formList]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    const fetchSubForm = async (FormID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const list = await HelpSiteService.GetSubFormByFormID(redirectCallback, FormID);
            setSubFormList(list);
        } catch (error) {
            console.error('Error fetching Asset Sub Categories:', error);
        }
    };
    const handleFormChange = (event) => {
        const { value } = event.target;
        setFormData({
            ...formData,
            FormID: value,
            //  FK_AssetSubCategoryID: 0
        });
        fetchSubForm(value);
    };
    const handleFormSubmit = (event) => {
        event.preventDefault();
        if (form) {
            formData.ID = form.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="helpSiteModal" tabIndex="-1" aria-labelledby="helpSiteModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="helpSiteModalLabel">{form ? "Edit Help Site" : "Add Help Site"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="FormID" className="col-sm-2 col-form-label">Select Module:</label>
                                    <div className="col-sm-4">
                                        <select name="FormID" className='form-control' value={formData.FormID} onChange={handleFormChange}>
                                            <option value="0">Select Module</option>
                                            {formList.map((form) => (
                                                <option key={form.ID} value={form.ID}>
                                                    {form.FormName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.FormID && <div style={{ color: 'red' }}>{errors.FormID}</div>}
                                    </div>
                                    <label htmlFor="ID" className="col-sm-2 col-form-label">Sub Form:</label>
                                    <div className="col-sm-4">
                                        <select name="ID" className='form-control' value={formData.ID} onChange={handleFieldChange}>
                                            <option value="0">Select Form</option>
                                            {subFormList.map((form) => (
                                                <option key={form.ID} value={form.ID}>
                                                    {form.SubForm}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.ID && <div style={{ color: 'red' }}>{errors.ID}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="HelpSite" className="col-sm-2 col-form-label">Help Site:</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="HelpSite"
                                            value={formData.HelpSite}
                                            onChange={handleFieldChange}
                                        />
                                        {errors.HelpSite && <div style={{ color: 'red' }}>{errors.HelpSite}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {form ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateHelpSite;
